import type { Editor } from 'hugerte';

import { YOUTUBE_ORIGIN } from '@change-corgi/core/richMediaTags';

/**
 * Since all iframes are sandboxed by default,
 * we need to add allow-scripts and allow-same-origin to youtube iframes to allow the video to play in editor.
 * This can be replaced by `sandbox_iframes_exclusions` if hugerte supports it.
 * see: https://www.tiny.cloud/docs/tinymce/latest/content-filtering/#sandbox-iframes-exclusions
 */
export function videoNodeFilter(editor: Editor): void {
	editor.parser.addNodeFilter('iframe', (nodes) => {
		nodes.forEach((node) => {
			const src = node.attr('src');
			if (src) {
				try {
					/**
					 * When any _valid_ youtube url is added to the editor, we only use the video id from the url
					 * and append it to the `YOUTUBE_BASE_PATH`. So we only validate that the url starts with `YOUTUBE_BASE_PATH` as expected.
					 * see: https://github.com/change/corgi/blob/c283f5dc86c025f6fc29a1f981a6bfe7eab114a8/apps/front-end/src/app/shared/components/richTextEditor/shared/config/richMediaConfigCallbacks/mediaUrlResolver.ts#L6-L19
					 */
					const url = new URL(src);
					if (url.origin === YOUTUBE_ORIGIN) {
						node.attr('sandbox', 'allow-scripts allow-same-origin');
					}
				} catch (e) {
					// Invalid URL, do nothing
				}
			}
		});
	});
}
